import { Component, computed, inject, input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CalendarEvent } from 'src/app/interfaces/interfaces';
import { DatetimeFormatService } from 'src/app/services/datetime-format-service/datetime-format.service';
import { BookingsStore } from 'src/app/stores/bookings.store';

@Component({
  selector: 'app-calendar-view-modal',
  templateUrl: './calendar-view-modal.component.html',
  styleUrls: ['./calendar-view-modal.component.scss'],
})
export class CalendarViewModalComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly bookingsStore = inject(BookingsStore);
  protected readonly formatService = inject(DatetimeFormatService);

  readonly events = computed(() => {
    const todayEvents = this.bookingsStore
      .allBookingsFull()
      .filter((booking) => {
        const start = new Date(booking.startTime).getDate();
        return start == new Date().getDate();
      })
      .map((booking) => {
        return {
          id: booking.id,
          title: booking.subject,
          start: new Date(booking.startTime),
          end: new Date(booking.endTime),
          color: (booking.isOrganizer ? 'green' : 'red') as 'green' | 'red',
          locationName: booking.place?.displayName || null,
        };
      });
    return todayEvents;
  });

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
